module.exports = {"title":"Vista 3D","appearance":"Apariencia","wireframe":"Malla","trimPlane":"Cortar plano","planeOpacity":"Opacidad","showIndicators":"Mostrar indicadores","resetCamera":"Reiniciar cámara"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/context/es/messages.json
// module id = 264
// module chunks = 0